// extracted by mini-css-extract-plugin
export default {"overViewCard":"styles_overViewCard__YnDc2"};